import React, { useContext, useState , useEffect } from 'react';
import Context from '../../../../context/context';
import LocalTaxiOutlinedIcon from '@mui/icons-material/LocalTaxiOutlined';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import TrainIcon from '@mui/icons-material/Train';


const TravelType = () => {
  const { state, dispatch } = useContext(Context);
   const [tripType, setTripType] = useState(state.tripType);// || 'סדירה'
   const [isTrain, setIsTrain] = useState(false);
  const addDataDispatch = (data) => dispatch({ type: "SET_TRIP_TYPE", payload: data });
  const setTrainDispatch = (data) => dispatch({ type: "SET_IS_TRAIN", payload: data });
  
  

  useEffect(()=>{
    // setTravelType(tripType);
    
  }, []);
  
  const setTravelType = (value) => {
    if(value === 'רכבת'){
  setTripType('רכבת');
        setIsTrain(true);
        setTrainDispatch(true);
    }else{
          setTripType(value);
          setTrainDispatch(false);
    }
    addDataDispatch(value);
  };

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {state.customerSettings?.allowPrivateOrdering ? 
        <div>
          <div
            className='box'
            variant="outlined"
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0fcff'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            onClick={() => setTravelType('פרטית')} 
          >
            <label className='typeText'>
              מונית פרטית &nbsp;
              <input
                name="tripType"
                type="radio"
                value="פרטית"
                onChange={(e) => setTravelType(e.target.value)}
                checked={tripType === 'פרטית'}
              />
            </label>
            <div className='icons'>
              <LocalTaxiOutlinedIcon className='icons' style={{fontSize: '80px'}}></LocalTaxiOutlinedIcon>
            </div>
          </div>
        </div>
        : <></>}

         {state.customerSettings?.allowTrainOrdering ? 
        <div>
          <div
            className='box'
            variant="outlined"
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0fcff'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            onClick={() => setTravelType('רכבת')} 
          >
            <label className='typeText'>
               רכבות &nbsp;
              <input
                name="tripType"
                type="radio"
                value="רכבת"
                onChange={(e) => setTravelType(e.target.value)}
                checked={tripType === 'רכבת'}
              />
            </label>
            <div className='icons'>
              <TrainIcon  className='icons' style={{fontSize: '80px'}}></TrainIcon>
            </div>
          </div>
        </div>
        : <></>}

      {state.customerSettings?.allowSadirOrdering ?
       <div style={{ marginLeft: '10px' }}>
          <div
            className='box'
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0fcff'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            variant="outlined"
            onClick={() => setTravelType('סדירה')} 
          >
            <label className='typeText'>
              הצטרפות להסעה ר"ה &nbsp;&nbsp;
              <input
                name="tripType"
                type="radio"
                value="סדירה"
                onChange={(e) => setTravelType(e.target.value)}
                checked={tripType === 'סדירה'}
              />
            </label>
            <div className='icons'>
              <AirportShuttleOutlinedIcon style={{ fontSize: '80px' }}></AirportShuttleOutlinedIcon>
            </div>
          </div>
        </div>
       : <></>}
        {/* // regular sadir */}

        {state.customerSettings?.allowRegularSadirOrdering ?
       <div style={{ marginLeft: '10px' }}>
          <div
            className='box'
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0fcff'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            variant="outlined"
            onClick={() => setTravelType('סדירה ר')} 
          >
            <label className='typeText'>
             הצטרפות להסעה &nbsp;&nbsp;
              <input
                name="tripType"
                type="radio"
                value="סדירה ר"
                onChange={(e) => setTravelType(e.target.value)}
                checked={tripType === 'סדירה ר'}
              />
            </label>
            <div className='icons'>
              <AirportShuttleOutlinedIcon style={{ fontSize: '80px' }}></AirportShuttleOutlinedIcon>
            </div>
          </div>
        </div>
       : <></>}
        
       
      </div>
    </div>
  );
};

export default TravelType;